module.exports = __webpack_public_path__ + "media/images/ticket/matome_warning_sp-ea02efee9f1312bc7cf295fe7fd14a7c.jpg";